// import { useState } from "react";

// const MODULES = [
//   {
//     id: "dashboard",
//     label: "Dashboard & Reporting",
//     icon: "📊",
//     color: "#1a73e8",
//     bg: "#e8f0fe",
//     features: [
//       { id: "business_dashboard", label: "Business Dashboard", description: "Main business overview" },
//       { id: "client_dashboard", label: "Client Dashboard", description: "Client-facing dashboard" },
//       { id: "operations_dashboard", label: "Operations Dashboard", description: "Ops metrics and KPIs" },
//       { id: "performance_reporting", label: "Performance Reporting", description: "User performance analytics" },
//       { id: "campaign_reporting", label: "Campaign Reporting", description: "Campaign analytics" },
//       { id: "entity_reporting", label: "Entity Reporting", description: "Entity-level reports" },
//       { id: "export_reports", label: "Export / Download Reports", description: "Export to PDF/Excel" },
//     ],
//   },
//   {
//     id: "supplier",
//     label: "Supplier Management",
//     icon: "🏭",
//     color: "#0f9d58",
//     bg: "#e6f4ea",
//     features: [
//       { id: "supplier_view", label: "View Suppliers", description: "Read supplier records" },
//       { id: "supplier_create", label: "Create Suppliers", description: "Add new supplier entries" },
//       { id: "supplier_edit", label: "Edit Suppliers", description: "Update supplier details" },
//       { id: "supplier_delete", label: "Delete Suppliers", description: "Remove supplier records" },
//       { id: "supplier_booking", label: "Booking Workflow", description: "Manage supplier bookings" },
//       { id: "supplier_pricing", label: "Pricing & Payment", description: "Manage negotiated pricing" },
//       { id: "supplier_categories", label: "Category Management", description: "Society, Gym, Salon, OOH etc." },
//       { id: "supplier_inventory", label: "Inventory Visibility", description: "View linked inventory IDs" },
//     ],
//   },
//   {
//     id: "inventory",
//     label: "Inventory Management",
//     icon: "📦",
//     color: "#e37400",
//     bg: "#fef3e2",
//     features: [
//       { id: "inventory_view", label: "View Inventory", description: "Read inventory records" },
//       { id: "inventory_update", label: "Update Inventory", description: "Edit inventory details" },
//       { id: "inventory_link", label: "Link to Supplier", description: "Associate inventory with supplier" },
//     ],
//   },
//   {
//     id: "leads",
//     label: "Leads & Campaigns",
//     icon: "🎯",
//     color: "#9334e6",
//     bg: "#f3e8fd",
//     features: [
//       { id: "leads_view", label: "View Leads", description: "Read lead records" },
//       { id: "leads_create", label: "Create Leads", description: "Add new leads" },
//       { id: "leads_assign", label: "Assign Leads", description: "Assign/unassign to users" },
//       { id: "leads_import", label: "Import Leads", description: "Bulk import with mapping" },
//       { id: "leads_comments", label: "Comments & Calls", description: "Add comments, quick-call" },
//       { id: "campaign_manage", label: "Campaign Management", description: "Create & track campaigns" },
//       { id: "proposal_create", label: "Create Proposals", description: "Generate proposals" },
//       { id: "proposal_approve", label: "Approve Proposals", description: "Accept / decline / on-hold" },
//       { id: "checklist_tasks", label: "Checklist Tasks", description: "Run operational checklists" },
//     ],
//   },
//   {
//     id: "communication",
//     label: "Communication & Engagement",
//     icon: "💬",
//     color: "#00796b",
//     bg: "#e0f2f1",
//     features: [
//       { id: "whatsapp_view", label: "WhatsApp Templates – View", description: "Read WA templates" },
//       { id: "whatsapp_manage", label: "WhatsApp Templates – Manage", description: "Create/edit/delete templates" },
//       { id: "whatsapp_optin", label: "Opt-in User Management", description: "Manage opted-in contacts" },
//       { id: "meta_signup", label: "Meta Embedded Signup", description: "Meta integration onboarding" },
//       { id: "sms_view", label: "SMS – View & Logs", description: "View SMS messages and logs" },
//       { id: "sms_send", label: "SMS – Create & Send", description: "Send SMS campaigns" },
//       { id: "webhook_config", label: "Webhook Bot Config", description: "Configure webhook bots" },
//       { id: "meta_forms", label: "Meta Forms", description: "Manage Meta lead forms" },
//     ],
//   },
//   {
//     id: "ai",
//     label: "AI, LLM & Automation",
//     icon: "🤖",
//     color: "#c5221f",
//     bg: "#fce8e6",
//     features: [
//       { id: "ai_chatbot", label: "AI Chatbot Interface", description: "Access AI assistant" },
//       { id: "ai_knowledgebase", label: "Knowledge Base Access", description: "Vector search & repos" },
//       { id: "ai_instructions", label: "Instruction Set Tools", description: "Create/edit AI instructions" },
//       { id: "ai_flow_builder", label: "Flow Builder", description: "Build automation flows" },
//       { id: "ai_scheduled", label: "Scheduled Message Flows", description: "Automate timed messages" },
//       { id: "ai_benchmarking", label: "Benchmarking Reports", description: "AI benchmark outputs" },
//       { id: "ai_embed", label: "Dynamic Chatbot Embed", description: "Embed chatbot in external pages" },
//     ],
//   },
//   {
//     id: "scraping",
//     label: "Scraping & Data Extraction",
//     icon: "🔍",
//     color: "#1565c0",
//     bg: "#e3f2fd",
//     features: [
//       { id: "scrape_web", label: "Web Scraping", description: "Scrape public web pages" },
//       { id: "scrape_pdf", label: "PDF Scraping", description: "Extract data from PDFs" },
//       { id: "scrape_video", label: "Video Scraping", description: "Extract from video sources" },
//       { id: "scrape_audio", label: "Audio Transcription", description: "Audio-to-text conversion" },
//       { id: "scrape_upload", label: "File Upload & Processing", description: "Upload & extract files" },
//       { id: "scrape_url_gen", label: "URL Generation", description: "Generate extraction URLs" },
//     ],
//   },
//   {
//     id: "forms",
//     label: "Forms & Content Management",
//     icon: "📝",
//     color: "#6a1b9a",
//     bg: "#f3e5f5",
//     features: [
//       { id: "form_create", label: "Create Forms", description: "Build entity/dataset forms" },
//       { id: "form_view", label: "View Data Records", description: "Read form submissions" },
//       { id: "form_update", label: "Update Submissions", description: "Edit form data" },
//       { id: "content_share", label: "Template & Content Sharing", description: "Share content assets" },
//       { id: "self_service", label: "Self-Service Form Access", description: "Public/self-service forms" },
//     ],
//   },
//   {
//     id: "admin",
//     label: "Admin, Account & Security",
//     icon: "🔐",
//     color: "#37474f",
//     bg: "#eceff1",
//     features: [
//       { id: "admin_profile", label: "Profile Management", description: "View/edit account info" },
//       { id: "admin_logs", label: "Activity & Login Logs", description: "Audit trail visibility" },
//       { id: "admin_permissions", label: "Permission Management", description: "Role & permission control" },
//       { id: "admin_settings", label: "Settings Management", description: "Platform settings" },
//       { id: "admin_notifications", label: "Notification Management", description: "Notification controls" },
//       { id: "admin_super", label: "Super Admin Features", description: "Operator-only controls" },
//     ],
//   },
//   {
//     id: "specialized",
//     label: "Specialized / Premium Modules",
//     icon: "⭐",
//     color: "#bf8c00",
//     bg: "#fff8e1",
//     features: [
//       { id: "studio_access", label: "Machadalo Studio", description: "Studio tools and assets" },
//       { id: "client_onboarding", label: "Client Onboarding", description: "Onboarding workflows" },
//       { id: "student_dashboard", label: "Student / Performance Dashboard", description: "Educational dashboards" },
//       { id: "parent_teacher", label: "Parent-Teacher Dashboard", description: "Parent/teacher views" },
//     ],
//   },
// ];

// const TIERS = [
//   { id: "free", label: "Free", color: "#607d8b" },
//   { id: "standard", label: "Standard", color: "#1a73e8" },
//   { id: "pro", label: "Pro", color: "#9334e6" },
//   { id: "enterprise", label: "Enterprise", color: "#0f9d58" },
// ];

// const ACTION_TYPES = ["view", "create", "edit", "delete", "approve", "export", "configure", "admin"];

// function buildInitialLicense() {
//   const data = {};
//   MODULES.forEach((mod) => {
//     data[mod.id] = {
//       enabled: false,
//       tier: "standard",
//       features: {},
//     };
//     mod.features.forEach((f) => {
//       data[mod.id].features[f.id] = {
//         enabled: false,
//         actions: {},
//       };
//       ACTION_TYPES.forEach((a) => {
//         data[mod.id].features[f.id].actions[a] = false;
//       });
//     });
//   });
//   return data;
// }

// const PRESET_PLANS = {
//   Free: {
//     dashboard: { enabled: true, tier: "free", features: { business_dashboard: { enabled: true, actions: { view: true } }, client_dashboard: { enabled: false }, campaign_reporting: { enabled: false } } },
//     supplier: { enabled: false },
//     inventory: { enabled: false },
//     leads: { enabled: true, tier: "free", features: { leads_view: { enabled: true, actions: { view: true } }, leads_create: { enabled: false } } },
//     communication: { enabled: false },
//     ai: { enabled: false },
//     scraping: { enabled: false },
//     forms: { enabled: true, tier: "free", features: { form_view: { enabled: true, actions: { view: true } }, self_service: { enabled: true, actions: { view: true } } } },
//     admin: { enabled: true, tier: "free", features: { admin_profile: { enabled: true, actions: { view: true, edit: true } }, admin_logs: { enabled: false } } },
//     specialized: { enabled: false },
//   },
//   Standard: {
//     dashboard: { enabled: true, tier: "standard" },
//     supplier: { enabled: true, tier: "standard" },
//     inventory: { enabled: true, tier: "standard" },
//     leads: { enabled: true, tier: "standard" },
//     communication: { enabled: true, tier: "standard", features: { whatsapp_view: { enabled: true, actions: { view: true } }, sms_view: { enabled: true, actions: { view: true } }, sms_send: { enabled: true, actions: { view: true, create: true } } } },
//     ai: { enabled: false },
//     scraping: { enabled: false },
//     forms: { enabled: true, tier: "standard" },
//     admin: { enabled: true, tier: "standard" },
//     specialized: { enabled: false },
//   },
//   Pro: {
//     dashboard: { enabled: true, tier: "pro" },
//     supplier: { enabled: true, tier: "pro" },
//     inventory: { enabled: true, tier: "pro" },
//     leads: { enabled: true, tier: "pro" },
//     communication: { enabled: true, tier: "pro" },
//     ai: { enabled: true, tier: "pro" },
//     scraping: { enabled: true, tier: "pro" },
//     forms: { enabled: true, tier: "pro" },
//     admin: { enabled: true, tier: "pro" },
//     specialized: { enabled: false },
//   },
//   Enterprise: {
//     dashboard: { enabled: true, tier: "enterprise" },
//     supplier: { enabled: true, tier: "enterprise" },
//     inventory: { enabled: true, tier: "enterprise" },
//     leads: { enabled: true, tier: "enterprise" },
//     communication: { enabled: true, tier: "enterprise" },
//     ai: { enabled: true, tier: "enterprise" },
//     scraping: { enabled: true, tier: "enterprise" },
//     forms: { enabled: true, tier: "enterprise" },
//     admin: { enabled: true, tier: "enterprise" },
//     specialized: { enabled: true, tier: "enterprise" },
//   },
// };

// function Toggle({ checked, onChange, size = "md" }) {
//   const w = size === "sm" ? 32 : 42;
//   const h = size === "sm" ? 18 : 24;
//   const r = size === "sm" ? 14 : 20;
//   return (
//     <div
//       onClick={() => onChange(!checked)}
//       style={{
//         width: w, height: h, borderRadius: h, background: checked ? "#1a73e8" : "#cfd8dc",
//         position: "relative", cursor: "pointer", transition: "background 0.2s", flexShrink: 0,
//       }}
//     >
//       <div style={{
//         position: "absolute", top: (h - r) / 2, left: checked ? w - r - (h - r) / 2 : (h - r) / 2,
//         width: r, height: r, borderRadius: "50%", background: "#fff",
//         transition: "left 0.2s", boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
//       }} />
//     </div>
//   );
// }

// function Badge({ label, color }) {
//   return (
//     <span style={{
//       background: color + "22", color: color, fontSize: 11, fontWeight: 600,
//       padding: "2px 8px", borderRadius: 20, letterSpacing: 0.3, textTransform: "uppercase",
//     }}>
//       {label}
//     </span>
//   );
// }

// function ActionChip({ action, checked, onChange }) {
//   const colors = {
//     view: "#1a73e8", create: "#0f9d58", edit: "#e37400", delete: "#c5221f",
//     approve: "#9334e6", export: "#00796b", configure: "#1565c0", admin: "#37474f",
//   };
//   const c = colors[action] || "#607d8b";
//   return (
//     <div
//       onClick={() => onChange(!checked)}
//       style={{
//         display: "flex", alignItems: "center", gap: 4, padding: "4px 10px",
//         borderRadius: 20, border: `1.5px solid ${checked ? c : "#cfd8dc"}`,
//         background: checked ? c + "15" : "#f5f5f5",
//         cursor: "pointer", transition: "all 0.15s", userSelect: "none",
//       }}
//     >
//       <div style={{ width: 6, height: 6, borderRadius: "50%", background: checked ? c : "#bdbdbd" }} />
//       <span style={{ fontSize: 11, fontWeight: 600, color: checked ? c : "#9e9e9e", textTransform: "capitalize" }}>
//         {action}
//       </span>
//     </div>
//   );
// }

// function FeatureRow({ feature, data, onChange }) {
//   const isEnabled = data?.enabled || false;
//   const actions = data?.actions || {};
//   return (
//     <div style={{
//       padding: "10px 16px", borderBottom: "1px solid #f0f0f0",
//       background: isEnabled ? "#fff" : "#fafafa", transition: "background 0.2s",
//     }}>
//       <div style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: isEnabled ? 8 : 0 }}>
//         <Toggle checked={isEnabled} onChange={(v) => onChange({ ...data, enabled: v })} size="sm" />
//         <div style={{ flex: 1 }}>
//           <div style={{ fontSize: 13, fontWeight: 600, color: isEnabled ? "#212121" : "#9e9e9e" }}>
//             {feature.label}
//           </div>
//           <div style={{ fontSize: 12, color: "#9e9e9e" }}>{feature.description}</div>
//         </div>
//       </div>
//       {isEnabled && (
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginLeft: 44 }}>
//           {ACTION_TYPES.map((a) => (
//             <ActionChip
//               key={a} action={a} checked={!!actions[a]}
//               onChange={(v) => onChange({ ...data, actions: { ...actions, [a]: v } })}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function ModuleCard({ module, data, onChange, expanded, onToggleExpand }) {
//   const isEnabled = data?.enabled || false;
//   const enabledFeatureCount = Object.values(data?.features || {}).filter((f) => f?.enabled).length;
//   const totalFeatures = module.features.length;

//   return (
//     <div style={{
//       border: `1.5px solid ${isEnabled ? module.color + "55" : "#e0e0e0"}`,
//       borderRadius: 12, overflow: "hidden", background: "#fff",
//       boxShadow: isEnabled ? `0 2px 12px ${module.color}18` : "none",
//       transition: "all 0.2s",
//     }}>
//       <div
//         style={{
//           padding: "14px 18px", background: isEnabled ? module.bg : "#f9f9f9",
//           cursor: "pointer", userSelect: "none",
//         }}
//         onClick={onToggleExpand}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <span style={{ fontSize: 22 }}>{module.icon}</span>
//           <div style={{ flex: 1 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
//               <span style={{ fontSize: 14, fontWeight: 700, color: "#212121" }}>{module.label}</span>
//               {isEnabled && (
//                 <Badge label={data?.tier || "standard"} color={TIERS.find((t) => t.id === (data?.tier || "standard"))?.color || "#607d8b"} />
//               )}
//             </div>
//             <div style={{ fontSize: 12, color: "#9e9e9e", marginTop: 2 }}>
//               {isEnabled ? `${enabledFeatureCount} / ${totalFeatures} features active` : "Module disabled"}
//             </div>
//           </div>
//           <Toggle
//             checked={isEnabled}
//             onChange={(v) => { onChange({ ...data, enabled: v }); }}
//           />
//           <span style={{ fontSize: 18, color: "#9e9e9e", marginLeft: 8 }}>{expanded ? "▲" : "▼"}</span>
//         </div>
//         {isEnabled && (
//           <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 12, color: "#757575" }}>Tier:</span>
//             {TIERS.map((tier) => (
//               <button
//                 key={tier.id}
//                 onClick={(e) => { e.stopPropagation(); onChange({ ...data, tier: tier.id }); }}
//                 style={{
//                   padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
//                   border: `1.5px solid ${(data?.tier || "standard") === tier.id ? tier.color : "#e0e0e0"}`,
//                   background: (data?.tier || "standard") === tier.id ? tier.color : "#fff",
//                   color: (data?.tier || "standard") === tier.id ? "#fff" : "#757575",
//                   transition: "all 0.15s",
//                 }}
//               >
//                 {tier.label}
//               </button>
//             ))}
//           </div>
//         )}
//       </div>
//       {expanded && isEnabled && (
//         <div>
//           <div style={{ padding: "8px 16px", background: "#f5f5f5", fontSize: 11, fontWeight: 700, color: "#9e9e9e", letterSpacing: 1, textTransform: "uppercase" }}>
//             Feature Permissions
//           </div>
//           {module.features.map((feature) => (
//             <FeatureRow
//               key={feature.id}
//               feature={feature}
//               data={data?.features?.[feature.id] || { enabled: false, actions: {} }}
//               onChange={(updated) => onChange({
//                 ...data,
//                 features: { ...(data?.features || {}), [feature.id]: updated },
//               })}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function JSONModal({ data, onClose }) {
//   const [copied, setCopied] = useState(false);
//   const json = JSON.stringify(data, null, 2);
//   const handleCopy = () => {
//     navigator.clipboard.writeText(json).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
//   };
//   return (
//     <div style={{
//       position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1000,
//       display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
//     }} onClick={onClose}>
//       <div style={{
//         background: "#1e1e2e", borderRadius: 16, width: "100%", maxWidth: 700,
//         maxHeight: "80vh", overflow: "hidden", display: "flex", flexDirection: "column",
//       }} onClick={(e) => e.stopPropagation()}>
//         <div style={{
//           padding: "16px 20px", borderBottom: "1px solid #333",
//           display: "flex", justifyContent: "space-between", alignItems: "center",
//         }}>
//           <span style={{ color: "#cdd6f4", fontWeight: 700, fontSize: 14 }}>License JSON Payload</span>
//           <div style={{ display: "flex", gap: 8 }}>
//             <button onClick={handleCopy} style={{
//               background: copied ? "#0f9d58" : "#313244", color: "#cdd6f4",
//               border: "none", borderRadius: 8, padding: "6px 14px", fontSize: 12,
//               cursor: "pointer", fontWeight: 600,
//             }}>
//               {copied ? "✓ Copied!" : "Copy JSON"}
//             </button>
//             <button onClick={onClose} style={{
//               background: "#45475a", color: "#cdd6f4", border: "none",
//               borderRadius: 8, padding: "6px 14px", fontSize: 12, cursor: "pointer",
//             }}>Close</button>
//           </div>
//         </div>
//         <pre style={{
//           margin: 0, padding: "16px 20px", color: "#cdd6f4", fontSize: 11.5,
//           lineHeight: 1.7, overflowY: "auto", fontFamily: "monospace",
//         }}>
//           {json}
//         </pre>
//       </div>
//     </div>
//   );
// }

// function StatsBar({ license }) {
//   const enabledModules = MODULES.filter((m) => license[m.id]?.enabled).length;
//   const totalFeatures = MODULES.reduce((acc, m) => acc + m.features.length, 0);
//   const enabledFeatures = MODULES.reduce((acc, m) => {
//     return acc + Object.values(license[m.id]?.features || {}).filter((f) => f?.enabled).length;
//   }, 0);
//   const totalActions = MODULES.reduce((acc, m) => {
//     return acc + Object.values(license[m.id]?.features || {}).reduce((fa, f) => {
//       return fa + Object.values(f?.actions || {}).filter(Boolean).length;
//     }, 0);
//   }, 0);

//   const stats = [
//     { label: "Modules Active", value: enabledModules, total: MODULES.length, color: "#1a73e8" },
//     { label: "Features Enabled", value: enabledFeatures, total: totalFeatures, color: "#0f9d58" },
//     { label: "Total Permissions", value: totalActions, color: "#9334e6" },
//   ];

//   return (
//     <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 24 }}>
//       {stats.map((s) => (
//         <div key={s.label} style={{
//           background: "#fff", borderRadius: 12, padding: "16px 20px",
//           border: "1.5px solid #f0f0f0",
//         }}>
//           <div style={{ fontSize: 26, fontWeight: 800, color: s.color }}>{s.value}{s.total ? <span style={{ fontSize: 14, color: "#bdbdbd", fontWeight: 400 }}>/{s.total}</span> : null}</div>
//           <div style={{ fontSize: 12, color: "#9e9e9e", marginTop: 2 }}>{s.label}</div>
//           {s.total && (
//             <div style={{ marginTop: 8, height: 4, borderRadius: 4, background: "#f0f0f0" }}>
//               <div style={{ width: `${(s.value / s.total) * 100}%`, height: "100%", borderRadius: 4, background: s.color, transition: "width 0.3s" }} />
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }

// export default function LicenseDashboard() {
//   const [license, setLicense] = useState(buildInitialLicense());
//   const [expandedModules, setExpandedModules] = useState({});
//   const [showJSON, setShowJSON] = useState(false);
//   const [activeTab, setActiveTab] = useState("builder");
//   const [clientName, setClientName] = useState("Client Name");
//   const [planName, setPlanName] = useState("Custom Plan");
//   const [searchQuery, setSearchQuery] = useState("");

//   const handleModuleChange = (modId, newData) => {
//     setLicense((prev) => ({ ...prev, [modId]: { ...prev[modId], ...newData } }));
//   };

//   const toggleExpand = (modId) => {
//     setExpandedModules((prev) => ({ ...prev, [modId]: !prev[modId] }));
//   };

//   const applyPreset = (presetName) => {
//     const preset = PRESET_PLANS[presetName];
//     const newLicense = buildInitialLicense();
//     Object.entries(preset).forEach(([modId, modData]) => {
//       if (!modData.enabled) return;
//       newLicense[modId].enabled = true;
//       newLicense[modId].tier = modData.tier || "standard";
//       if (modData.features) {
//         Object.entries(modData.features).forEach(([fId, fData]) => {
//           if (newLicense[modId].features[fId]) {
//             newLicense[modId].features[fId].enabled = fData.enabled || false;
//             if (fData.actions) {
//               Object.entries(fData.actions).forEach(([a, v]) => {
//                 newLicense[modId].features[fId].actions[a] = v;
//               });
//             }
//           }
//         });
//       } else {
//         MODULES.find((m) => m.id === modId)?.features.forEach((f) => {
//           newLicense[modId].features[f.id].enabled = true;
//           ACTION_TYPES.forEach((a) => { newLicense[modId].features[f.id].actions[a] = ["view"].includes(a); });
//         });
//       }
//     });
//     setLicense(newLicense);
//     setPlanName(presetName);
//   };

//   const enableAll = () => {
//     const newLicense = buildInitialLicense();
//     MODULES.forEach((mod) => {
//       newLicense[mod.id].enabled = true;
//       newLicense[mod.id].tier = "enterprise";
//       mod.features.forEach((f) => {
//         newLicense[mod.id].features[f.id].enabled = true;
//         ACTION_TYPES.forEach((a) => { newLicense[mod.id].features[f.id].actions[a] = true; });
//       });
//     });
//     setLicense(newLicense);
//   };

//   const disableAll = () => { setLicense(buildInitialLicense()); };

//   const filteredModules = MODULES.filter((m) =>
//     searchQuery === "" ||
//     m.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     m.features.some((f) => f.label.toLowerCase().includes(searchQuery.toLowerCase()))
//   );

//   const exportPayload = {
//     client: clientName,
//     plan: planName,
//     generatedAt: new Date().toISOString(),
//     license,
//   };

//   return (
//     <div style={{ minHeight: "100vh", background: "#f4f6f9", fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
//       {/* Header */}
//       <div style={{ background: "#fff", borderBottom: "1.5px solid #e0e0e0", padding: "0 24px", position: "sticky", top: 0, zIndex: 100 }}>
//         <div style={{ maxWidth: 960, margin: "0 auto", display: "flex", alignItems: "center", gap: 16, height: 60 }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <div style={{ width: 32, height: 32, borderRadius: 8, background: "linear-gradient(135deg,#1a73e8,#9334e6)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//               <span style={{ color: "#fff", fontSize: 16 }}>🔑</span>
//             </div>
//             <span style={{ fontSize: 16, fontWeight: 800, color: "#212121", letterSpacing: -0.3 }}>Machadalo</span>
//             <span style={{ fontSize: 13, color: "#9e9e9e" }}>/ License Dashboard</span>
//           </div>
//           <div style={{ flex: 1 }} />
//           <button onClick={() => setShowJSON(true)} style={{
//             background: "#212121", color: "#fff", border: "none", borderRadius: 8,
//             padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer",
//             display: "flex", alignItems: "center", gap: 6,
//           }}>
//             {"</>"} Export JSON
//           </button>
//         </div>
//       </div>

//       <div style={{ maxWidth: 960, margin: "0 auto", padding: "24px 24px" }}>
//         {/* Client Info */}
//         <div style={{ background: "#fff", borderRadius: 12, padding: "16px 20px", marginBottom: 20, border: "1.5px solid #e0e0e0" }}>
//           <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "center" }}>
//             <div style={{ flex: 1, minWidth: 180 }}>
//               <label style={{ fontSize: 11, fontWeight: 700, color: "#9e9e9e", textTransform: "uppercase", letterSpacing: 1 }}>Client Name</label>
//               <input
//                 value={clientName}
//                 onChange={(e) => setClientName(e.target.value)}
//                 style={{ display: "block", width: "100%", marginTop: 4, padding: "8px 12px", borderRadius: 8, border: "1.5px solid #e0e0e0", fontSize: 14, fontWeight: 600, color: "#212121", outline: "none", boxSizing: "border-box" }}
//               />
//             </div>
//             <div style={{ flex: 1, minWidth: 180 }}>
//               <label style={{ fontSize: 11, fontWeight: 700, color: "#9e9e9e", textTransform: "uppercase", letterSpacing: 1 }}>Plan Name</label>
//               <input
//                 value={planName}
//                 onChange={(e) => setPlanName(e.target.value)}
//                 style={{ display: "block", width: "100%", marginTop: 4, padding: "8px 12px", borderRadius: 8, border: "1.5px solid #e0e0e0", fontSize: 14, fontWeight: 600, color: "#212121", outline: "none", boxSizing: "border-box" }}
//               />
//             </div>
//             <div>
//               <label style={{ fontSize: 11, fontWeight: 700, color: "#9e9e9e", textTransform: "uppercase", letterSpacing: 1 }}>Quick Presets</label>
//               <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
//                 {Object.keys(PRESET_PLANS).map((p) => (
//                   <button key={p} onClick={() => applyPreset(p)} style={{
//                     padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600,
//                     border: "1.5px solid #e0e0e0", background: "#f5f5f5", color: "#424242",
//                     cursor: "pointer", transition: "all 0.15s",
//                   }}>
//                     {p}
//                   </button>
//                 ))}
//                 <button onClick={enableAll} style={{ padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, border: "1.5px solid #0f9d58", background: "#e6f4ea", color: "#0f9d58", cursor: "pointer" }}>All On</button>
//                 <button onClick={disableAll} style={{ padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, border: "1.5px solid #c5221f", background: "#fce8e6", color: "#c5221f", cursor: "pointer" }}>Reset</button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Stats */}
//         <StatsBar license={license} />

//         {/* Search */}
//         <div style={{ marginBottom: 16, position: "relative" }}>
//           <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "#9e9e9e", fontSize: 16 }}>🔍</span>
//           <input
//             placeholder="Search modules or features..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             style={{
//               width: "100%", padding: "10px 14px 10px 40px", borderRadius: 10,
//               border: "1.5px solid #e0e0e0", fontSize: 14, color: "#212121",
//               background: "#fff", outline: "none", boxSizing: "border-box",
//             }}
//           />
//         </div>

//         {/* Module Cards */}
//         <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
//           {filteredModules.map((mod) => (
//             <ModuleCard
//               key={mod.id}
//               module={mod}
//               data={license[mod.id]}
//               onChange={(newData) => handleModuleChange(mod.id, newData)}
//               expanded={!!expandedModules[mod.id]}
//               onToggleExpand={() => toggleExpand(mod.id)}
//             />
//           ))}
//         </div>

//         {/* Footer */}
//         <div style={{ marginTop: 32, textAlign: "center", color: "#bdbdbd", fontSize: 12 }}>
//           Machadalo License Dashboard · {new Date().toLocaleDateString()} · {Object.values(license).filter((m) => m.enabled).length} modules active
//         </div>
//       </div>

//       {showJSON && <JSONModal data={exportPayload} onClose={() => setShowJSON(false)} />}
//     </div>
//   );
// }

// LicenseDashboard.tsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  Card,
  CardContent,
  Divider,
  Chip,
  Avatar,
  LinearProgress,
  Tooltip,
  Fade,
  Grow,
  Stack,
  IconButton,
  Container,
  useTheme,
  alpha,
  Switch,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  InputAdornment,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission';
import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../Services/_states';
import OrganisationDropdown from '../Shared/OrganisationDropdown/index.tsx';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import {
  CATEGORIES_WITH_SUBCATEGORIES,
  getCategoryLabel,
  getCategoryColor,
  getCategoryIcon,
  getSubCategories,
} from '../MachadaloStudio/categoryData.ts';

// ─── Icons ──────────────────────────────────────────────────────────────────
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DateRangeIcon from '@mui/icons-material/DateRange';
import TimerIcon from '@mui/icons-material/Timer';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

// ─── Styled Components ──────────────────────────────────────────────────────

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 16,
  background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
  boxShadow: '0 8px 32px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)',
  border: '1px solid rgba(0,0,0,0.04)',
}));

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  boxShadow: 'none !important',
  padding: theme.spacing(1, 0),
}));

const LicenseCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  transition: 'all 0.2s ease',
  border: '1px solid rgba(0,0,0,0.06)',
  height: '100%',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    transform: 'translateY(-2px)',
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: '#fafafa',
    transition: 'all 0.2s ease',
    '&:hover': { backgroundColor: '#f5f5f5' },
    '&.Mui-focused': {
      backgroundColor: '#ffffff',
      boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.12)}`,
    },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 500,
    color: theme.palette.text.secondary,
    fontSize: '0.8125rem',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.primary.main,
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: 8,
  backgroundColor: '#fafafa',
  '&:hover': { backgroundColor: '#f5f5f5' },
  '&.Mui-focused': {
    backgroundColor: '#ffffff',
    boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.12)}`,
  },
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(2.5),
  paddingBottom: theme.spacing(1),
  borderBottom: '2px solid #f0f0f0',
}));

const FieldLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.8125rem',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
}));

const RequiredStar = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
  marginLeft: 2,
}));

const StatusBadge = styled(Chip)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.65rem',
  height: 24,
}));

// ─── Types ──────────────────────────────────────────────────────────────────

interface LicenseData {
  id?: string;
  licenseType: string;
  organizationId: string;
  businessFunction: string;
  subFunction: string;
  licenseKey: string;
  startDate: string;
  endDate: string;
  userCount: number;
  cost: number;
  duration: number;
  status: 'active' | 'expired' | 'pending' | 'suspended';
  aiModuleIncluded: boolean;
  features: string[];
  modulePermissions: Record<string, { view: boolean; create: boolean; edit: boolean; delete: boolean }>;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

// ─── MODULES from your commented code ──────────────────────────────────────

const MODULES = [
  {
    id: "dashboard",
    label: "Dashboard & Reporting",
    icon: "📊",
    color: "#1a73e8",
    bg: "#e8f0fe",
    features: [
      { id: "business_dashboard", label: "Business Dashboard", description: "Main business overview" },
      { id: "client_dashboard", label: "Client Dashboard", description: "Client-facing dashboard" },
      { id: "operations_dashboard", label: "Operations Dashboard", description: "Ops metrics and KPIs" },
      { id: "performance_reporting", label: "Performance Reporting", description: "User performance analytics" },
      { id: "campaign_reporting", label: "Campaign Reporting", description: "Campaign analytics" },
      { id: "entity_reporting", label: "Entity Reporting", description: "Entity-level reports" },
      { id: "export_reports", label: "Export / Download Reports", description: "Export to PDF/Excel" },
    ],
  },
  {
    id: "supplier",
    label: "Supplier Management",
    icon: "🏭",
    color: "#0f9d58",
    bg: "#e6f4ea",
    features: [
      { id: "supplier_view", label: "View Suppliers", description: "Read supplier records" },
      { id: "supplier_create", label: "Create Suppliers", description: "Add new supplier entries" },
      { id: "supplier_edit", label: "Edit Suppliers", description: "Update supplier details" },
      { id: "supplier_delete", label: "Delete Suppliers", description: "Remove supplier records" },
      { id: "supplier_booking", label: "Booking Workflow", description: "Manage supplier bookings" },
      { id: "supplier_pricing", label: "Pricing & Payment", description: "Manage negotiated pricing" },
      { id: "supplier_categories", label: "Category Management", description: "Society, Gym, Salon, OOH etc." },
      { id: "supplier_inventory", label: "Inventory Visibility", description: "View linked inventory IDs" },
    ],
  },
  {
    id: "inventory",
    label: "Inventory Management",
    icon: "📦",
    color: "#e37400",
    bg: "#fef3e2",
    features: [
      { id: "inventory_view", label: "View Inventory", description: "Read inventory records" },
      { id: "inventory_update", label: "Update Inventory", description: "Edit inventory details" },
      { id: "inventory_link", label: "Link to Supplier", description: "Associate inventory with supplier" },
    ],
  },
  {
    id: "leads",
    label: "Leads & Campaigns",
    icon: "🎯",
    color: "#9334e6",
    bg: "#f3e8fd",
    features: [
      { id: "leads_view", label: "View Leads", description: "Read lead records" },
      { id: "leads_create", label: "Create Leads", description: "Add new leads" },
      { id: "leads_assign", label: "Assign Leads", description: "Assign/unassign to users" },
      { id: "leads_import", label: "Import Leads", description: "Bulk import with mapping" },
      { id: "leads_comments", label: "Comments & Calls", description: "Add comments, quick-call" },
      { id: "campaign_manage", label: "Campaign Management", description: "Create & track campaigns" },
      { id: "proposal_create", label: "Create Proposals", description: "Generate proposals" },
      { id: "proposal_approve", label: "Approve Proposals", description: "Accept / decline / on-hold" },
      { id: "checklist_tasks", label: "Checklist Tasks", description: "Run operational checklists" },
    ],
  },
  {
    id: "communication",
    label: "Communication & Engagement",
    icon: "💬",
    color: "#00796b",
    bg: "#e0f2f1",
    features: [
      { id: "whatsapp_view", label: "WhatsApp Templates – View", description: "Read WA templates" },
      { id: "whatsapp_manage", label: "WhatsApp Templates – Manage", description: "Create/edit/delete templates" },
      { id: "whatsapp_optin", label: "Opt-in User Management", description: "Manage opted-in contacts" },
      { id: "meta_signup", label: "Meta Embedded Signup", description: "Meta integration onboarding" },
      { id: "sms_view", label: "SMS – View & Logs", description: "View SMS messages and logs" },
      { id: "sms_send", label: "SMS – Create & Send", description: "Send SMS campaigns" },
      { id: "webhook_config", label: "Webhook Bot Config", description: "Configure webhook bots" },
      { id: "meta_forms", label: "Meta Forms", description: "Manage Meta lead forms" },
    ],
  },
  {
    id: "ai",
    label: "AI, LLM & Automation",
    icon: "🤖",
    color: "#c5221f",
    bg: "#fce8e6",
    features: [
      { id: "ai_chatbot", label: "AI Chatbot Interface", description: "Access AI assistant" },
      { id: "ai_knowledgebase", label: "Knowledge Base Access", description: "Vector search & repos" },
      { id: "ai_instructions", label: "Instruction Set Tools", description: "Create/edit AI instructions" },
      { id: "ai_flow_builder", label: "Flow Builder", description: "Build automation flows" },
      { id: "ai_scheduled", label: "Scheduled Message Flows", description: "Automate timed messages" },
      { id: "ai_benchmarking", label: "Benchmarking Reports", description: "AI benchmark outputs" },
      { id: "ai_embed", label: "Dynamic Chatbot Embed", description: "Embed chatbot in external pages" },
    ],
  },
  {
    id: "scraping",
    label: "Scraping & Data Extraction",
    icon: "🔍",
    color: "#1565c0",
    bg: "#e3f2fd",
    features: [
      { id: "scrape_web", label: "Web Scraping", description: "Scrape public web pages" },
      { id: "scrape_pdf", label: "PDF Scraping", description: "Extract data from PDFs" },
      { id: "scrape_video", label: "Video Scraping", description: "Extract from video sources" },
      { id: "scrape_audio", label: "Audio Transcription", description: "Audio-to-text conversion" },
      { id: "scrape_upload", label: "File Upload & Processing", description: "Upload & extract files" },
      { id: "scrape_url_gen", label: "URL Generation", description: "Generate extraction URLs" },
    ],
  },
  {
    id: "forms",
    label: "Forms & Content Management",
    icon: "📝",
    color: "#6a1b9a",
    bg: "#f3e5f5",
    features: [
      { id: "form_create", label: "Create Forms", description: "Build entity/dataset forms" },
      { id: "form_view", label: "View Data Records", description: "Read form submissions" },
      { id: "form_update", label: "Update Submissions", description: "Edit form data" },
      { id: "content_share", label: "Template & Content Sharing", description: "Share content assets" },
      { id: "self_service", label: "Self-Service Form Access", description: "Public/self-service forms" },
    ],
  },
  {
    id: "admin",
    label: "Admin, Account & Security",
    icon: "🔐",
    color: "#37474f",
    bg: "#eceff1",
    features: [
      { id: "admin_profile", label: "Profile Management", description: "View/edit account info" },
      { id: "admin_logs", label: "Activity & Login Logs", description: "Audit trail visibility" },
      { id: "admin_permissions", label: "Permission Management", description: "Role & permission control" },
      { id: "admin_settings", label: "Settings Management", description: "Platform settings" },
      { id: "admin_notifications", label: "Notification Management", description: "Notification controls" },
      { id: "admin_super", label: "Super Admin Features", description: "Operator-only controls" },
    ],
  },
  {
    id: "specialized",
    label: "Specialized / Premium Modules",
    icon: "⭐",
    color: "#bf8c00",
    bg: "#fff8e1",
    features: [
      { id: "studio_access", label: "Machadalo AI Suite", description: "Studio tools and assets" },
      { id: "client_onboarding", label: "Client Onboarding", description: "Onboarding workflows" },
      { id: "student_dashboard", label: "Student / Performance Dashboard", description: "Educational dashboards" },
      { id: "parent_teacher", label: "Parent-Teacher Dashboard", description: "Parent/teacher views" },
    ],
  },
];

const ACTION_TYPES = ["view", "create", "edit", "delete"];

// ─── Main Component ──────────────────────────────────────────────────────────

const LicenseDashboard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { showSnackBar } = useSnackBar();
  const actions = ConstantActions();
  const userInfo = useRecoilValue(userInformationAtom);
  const isSuperuser = userInfo?.is_superuser === true || userInfo?.profile?.name === 'Admin';

  // ─── State ──────────────────────────────────────────────────────────────────
  const [licenses, setLicenses] = useState<LicenseData[]>([]);
  const [filteredLicenses, setFilteredLicenses] = useState<LicenseData[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<'list' | 'create' | 'edit'>('list');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState<string>('all');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [licenseToDelete, setLicenseToDelete] = useState<string | null>(null);
  const [editingLicense, setEditingLicense] = useState<LicenseData | null>(null);
  const [selectedOrganisation, setSelectedOrganisation] = useState<any>(null);
  const [expandedModules, setExpandedModules] = useState<Record<string, boolean>>({});

  // ─── License Types ──────────────────────────────────────────────────────────
  const licenseTypes = ['Platinum', 'Gold', 'Silver', 'Basic', 'Enterprise'];

  // ─── Features ───────────────────────────────────────────────────────────────
  const availableFeatures = [
    'AI Module',
    'Analytics Dashboard',
    'Advanced Reporting',
    'API Access',
    'Custom Integrations',
    'Priority Support',
    'Data Export',
    'User Management',
    'Template Library',
    'Knowledge Map Access',
  ];

  // ─── Form State ─────────────────────────────────────────────────────────────
  const [formData, setFormData] = useState<Partial<LicenseData>>({
    licenseType: '',
    organizationId: '',
    businessFunction: '',
    subFunction: '',
    licenseKey: '',
    startDate: '',
    endDate: '',
    userCount: 1,
    cost: 0,
    duration: 12,
    aiModuleIncluded: false,
    features: [],
    modulePermissions: {},
    status: 'active',
  });

  // ─── Mock Data ──────────────────────────────────────────────────────────────
  const mockLicenses: LicenseData[] = [
    {
      id: 'LIC001',
      licenseType: 'Platinum',
      organizationId: 'MACSCH4026',
      businessFunction: 'overview',
      subFunction: 'Executive Summary',
      licenseKey: 'PLAT-2024-X7K9-M3N5',
      startDate: '2024-01-15',
      endDate: '2025-01-15',
      userCount: 50,
      cost: 99999,
      duration: 12,
      status: 'active',
      aiModuleIncluded: true,
      features: ['AI Module', 'Analytics Dashboard', 'API Access', 'Priority Support'],
      modulePermissions: {
        'dashboard': { view: true, create: true, edit: true, delete: true },
        'supplier': { view: true, create: true, edit: true, delete: true },
        'leads': { view: true, create: true, edit: false, delete: false },
        'ai': { view: true, create: false, edit: false, delete: false },
      },
      createdBy: 'aayush singh',
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z',
    },
    {
      id: 'LIC002',
      licenseType: 'Gold',
      organizationId: 'MACSCH4027',
      businessFunction: 'marketing',
      subFunction: 'Campaign Management',
      licenseKey: 'GOLD-2024-A4B8-C2D6',
      startDate: '2024-02-01',
      endDate: '2024-08-01',
      userCount: 25,
      cost: 49999,
      duration: 6,
      status: 'active',
      aiModuleIncluded: true,
      features: ['AI Module', 'Analytics Dashboard', 'Advanced Reporting'],
      modulePermissions: {
        'dashboard': { view: true, create: true, edit: true, delete: false },
        'leads': { view: true, create: true, edit: true, delete: false },
        'communication': { view: true, create: false, edit: false, delete: false },
      },
      createdBy: 'Rahul Rathore',
      createdAt: '2024-02-01T10:00:00Z',
      updatedAt: '2024-02-01T10:00:00Z',
    },
  ];

  // ─── Initialize ─────────────────────────────────────────────────────────────
  useEffect(() => {
    fetchLicenses();
  }, []);

  const fetchLicenses = async () => {
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 800));
      setLicenses(mockLicenses);
      setFilteredLicenses(mockLicenses);
    } catch (error) {
      showSnackBar('Error fetching licenses', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  // ─── Filtering ──────────────────────────────────────────────────────────────
  useEffect(() => {
    let filtered = [...licenses];

    if (searchTerm) {
      filtered = filtered.filter(
        (l) =>
          l.licenseType.toLowerCase().includes(searchTerm.toLowerCase()) ||
          l.licenseKey.toLowerCase().includes(searchTerm.toLowerCase()) ||
          getCategoryLabel(l.businessFunction).toLowerCase().includes(searchTerm.toLowerCase()) ||
          l.subFunction?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (filterStatus !== 'all') {
      filtered = filtered.filter((l) => l.status === filterStatus);
    }

    setFilteredLicenses(filtered);
  }, [searchTerm, filterStatus, licenses]);

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const handleCreateLicense = async () => {
    if (!validateLicenseData(formData)) return;

    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      const newLicense: LicenseData = {
        ...(formData as LicenseData),
        id: `LIC${String(licenses.length + 1).padStart(3, '0')}`,
        licenseKey: generateLicenseKey(formData.licenseType || 'BASIC'),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        status: 'active',
        modulePermissions: formData.modulePermissions || {},
      };
      setLicenses([newLicense, ...licenses]);
      showSnackBar('License created successfully!', 'success');
      setActiveTab('list');
      resetForm();
    } catch (error) {
      showSnackBar('Error creating license', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateLicense = async () => {
    if (!validateLicenseData(formData)) return;

    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      const updatedLicenses = licenses.map((license) =>
        license.id === editingLicense?.id
          ? { ...license, ...formData, updatedAt: new Date().toISOString() }
          : license
      );
      setLicenses(updatedLicenses);
      showSnackBar('License updated successfully!', 'success');
      setActiveTab('list');
      setEditingLicense(null);
      resetForm();
    } catch (error) {
      showSnackBar('Error updating license', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteLicense = async () => {
    if (!licenseToDelete) return;
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      setLicenses(licenses.filter((license) => license.id !== licenseToDelete));
      showSnackBar('License deleted successfully!', 'success');
      setDeleteDialogOpen(false);
      setLicenseToDelete(null);
    } catch (error) {
      showSnackBar('Error deleting license', 'error');
    }
  };

  // ─── Helper Functions ──────────────────────────────────────────────────────

  const generateLicenseKey = (type: string): string => {
    const prefix = type.substring(0, 4).toUpperCase();
    const random = Math.random().toString(36).substring(2, 10).toUpperCase();
    const year = new Date().getFullYear();
    return `${prefix}-${year}-${random}`;
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active': return 'success';
      case 'expired': return 'error';
      case 'pending': return 'warning';
      case 'suspended': return 'default';
      default: return 'default';
    }
  };

  const getStatusLabel = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  const getDaysRemaining = (endDate: string) => {
    const end = new Date(endDate);
    const now = new Date();
    const diff = Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    return diff > 0 ? diff : 0;
  };

  const getLicenseTypeColor = (type: string) => {
    switch (type) {
      case 'Platinum': return '#7B1FA2';
      case 'Gold': return '#F57F17';
      case 'Silver': return '#78909C';
      case 'Basic': return '#1976D2';
      case 'Enterprise': return '#D32F2F';
      default: return '#1976D2';
    }
  };

  const formatINR = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // ─── Validation ─────────────────────────────────────────────────────────────

  const validateLicenseData = (data: Partial<LicenseData>) => {
    const newErrors: Record<string, string> = {};

    if (!data.licenseType) newErrors.licenseType = 'License type is required';
    if (!data.organizationId) newErrors.organizationId = 'Organization is required';
    if (!data.businessFunction) newErrors.businessFunction = 'Business function is required';
    if (!data.startDate) newErrors.startDate = 'Start date is required';
    if (!data.endDate) newErrors.endDate = 'End date is required';
    if (!data.userCount || data.userCount <= 0) newErrors.userCount = 'User count must be greater than 0';
    if (!data.cost || data.cost <= 0) newErrors.cost = 'Cost must be greater than 0';
    if (!data.duration || data.duration <= 0) newErrors.duration = 'Duration must be greater than 0';

    if (data.startDate && data.endDate && data.startDate > data.endDate) {
      newErrors.endDate = 'End date must be after start date';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ─── Form Handlers ──────────────────────────────────────────────────────────

  const resetForm = () => {
    setFormData({
      licenseType: '',
      organizationId: '',
      businessFunction: '',
      subFunction: '',
      licenseKey: '',
      startDate: '',
      endDate: '',
      userCount: 1,
      cost: 0,
      duration: 12,
      aiModuleIncluded: false,
      features: [],
      modulePermissions: {},
      status: 'active',
    });
    setErrors({});
    setSelectedOrganisation(null);
  };

  const handleFormChange = (field: string, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const handleEditLicense = (license: LicenseData) => {
    setEditingLicense(license);
    setFormData(license);
    setActiveTab('edit');
    setSelectedOrganisation({ organisation_id: license.organizationId });
  };

  const toggleModuleExpand = (moduleId: string) => {
    setExpandedModules((prev) => ({ ...prev, [moduleId]: !prev[moduleId] }));
  };

  // ─── Module Permission Handlers ──────────────────────────────────────────

  const handleModulePermissionChange = (
    moduleId: string,
    action: 'view' | 'create' | 'edit' | 'delete',
    value: boolean
  ) => {
    setFormData((prev) => ({
      ...prev,
      modulePermissions: {
        ...prev.modulePermissions,
        [moduleId]: {
          ...(prev.modulePermissions?.[moduleId] || { view: false, create: false, edit: false, delete: false }),
          [action]: value,
        },
      },
    }));
  };

  const handleModuleToggle = (moduleId: string, enabled: boolean) => {
    if (enabled) {
      // Enable all actions for this module
      setFormData((prev) => ({
        ...prev,
        modulePermissions: {
          ...prev.modulePermissions,
          [moduleId]: { view: true, create: true, edit: true, delete: true },
        },
      }));
    } else {
      // Disable all actions for this module
      setFormData((prev) => {
        const newPermissions = { ...prev.modulePermissions };
        delete newPermissions[moduleId];
        return {
          ...prev,
          modulePermissions: newPermissions,
        };
      });
    }
  };

  // ─── Render Module Permission using SearchableDropdown ──────────────────

  const renderModulePermissions = () => {
    // Prepare options for SearchableDropdown
    const moduleOptions = MODULES.map(m => ({
      label: `${m.icon} ${m.label}`,
      value: m.id,
      module: m,
    }));

    const selectedModules = Object.keys(formData.modulePermissions || {});

    return (
      <Box sx={{ mt: 2 }}>
        <FieldLabel>
          <LockIcon sx={{ fontSize: 18 }} />
          Module Permissions
        </FieldLabel>
        <Typography variant="caption" color="textSecondary">
          Search and select modules to grant View/Create/Edit/Delete permissions
        </Typography>

        {/* Searchable Dropdown for Module Selection */}
        <Box sx={{ mt: 1.5, mb: 2 }}>
          <SearchableDropdown
            options={moduleOptions}
            labelKey="label"
            valueKey="value"
            label="Search and add modules..."
            value={selectedModules.map(id => {
              const mod = MODULES.find(m => m.id === id);
              return mod ? { label: `${mod.icon} ${mod.label}`, value: mod.id, module: mod } : null;
            }).filter(Boolean)}
            onChange={(selected: any) => {
              if (selected && Array.isArray(selected)) {
                // Enable permissions for selected modules
                const newPermissions = { ...formData.modulePermissions };
                selected.forEach((item: any) => {
                  if (item?.value) {
                    // Only add if not already present
                    if (!newPermissions[item.value]) {
                      newPermissions[item.value] = { view: true, create: true, edit: true, delete: true };
                    }
                  }
                });
                // Remove modules that are no longer selected
                const selectedIds = selected.map((s: any) => s?.value).filter(Boolean);
                Object.keys(newPermissions).forEach(key => {
                  if (!selectedIds.includes(key)) {
                    delete newPermissions[key];
                  }
                });
                setFormData((prev) => ({
                  ...prev,
                  modulePermissions: newPermissions,
                }));
              }
            }}
            multiSelect={true}
            size="small"
            sx={{ width: '100%' }}
          />
        </Box>

        {/* Selected Module Permissions Cards */}
        {selectedModules.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {selectedModules.map((moduleId) => {
              const module = MODULES.find(m => m.id === moduleId);
              if (!module) return null;
              const permissions = formData.modulePermissions?.[moduleId] || { view: false, create: false, edit: false, delete: false };
              const isExpanded = expandedModules[moduleId] || false;

              return (
                <Card key={moduleId} sx={{ border: '1px solid #e8ecf4', borderRadius: 2, overflow: 'hidden' }}>
                  <ListItemButton
                    onClick={() => toggleModuleExpand(moduleId)}
                    sx={{
                      bgcolor: alpha(module.color || '#1976D2', 0.08),
                      py: 1.5,
                    }}
                  >
                    <ListItemIcon>
                      <Typography fontSize={24}>{module.icon}</Typography>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography fontWeight={600}>{module.label}</Typography>
                          <Chip
                            label="Permissions Granted"
                            size="small"
                            color="success"
                            sx={{ fontSize: '0.55rem', height: 18 }}
                          />
                        </Box>
                      }
                      secondary={`${module.features.length} features available`}
                    />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                  </ListItemButton>

                  <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <Box sx={{ p: 2, bgcolor: '#fafbfc' }}>
                      <Grid container spacing={1}>
                        {ACTION_TYPES.map((action) => {
                          const actionLabels: Record<string, string> = {
                            view: '👁️ View',
                            create: '➕ Create',
                            edit: '✏️ Edit',
                            delete: '🗑️ Delete',
                          };
                          const actionColors: Record<string, string> = {
                            view: '#1a73e8',
                            create: '#0f9d58',
                            edit: '#e37400',
                            delete: '#c5221f',
                          };
                          return (
                            <Grid item xs={6} sm={3} key={action}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={permissions[action as keyof typeof permissions] || false}
                                    onChange={(e) => handleModulePermissionChange(
                                      moduleId,
                                      action as 'view' | 'create' | 'edit' | 'delete',
                                      e.target.checked
                                    )}
                                    size="small"
                                    sx={{
                                      color: permissions[action as keyof typeof permissions] ? actionColors[action] : '#bdbdbd',
                                      '&.Mui-checked': {
                                        color: actionColors[action],
                                      },
                                    }}
                                  />
                                }
                                label={
                                  <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                    {actionLabels[action]}
                                  </Typography>
                                }
                              />
                            </Grid>
                          );
                        })}
                      </Grid>

                      {/* Show some features for this module */}
                      <Box sx={{ mt: 1.5, pt: 1.5, borderTop: '1px solid #e8ecf4' }}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.65rem' }}>
                          Features: {module.features.slice(0, 3).map(f => f.label).join(', ')}
                          {module.features.length > 3 && ` +${module.features.length - 3} more`}
                        </Typography>
                      </Box>
                    </Box>
                  </Collapse>
                </Card>
              );
            })}
          </Box>
        ) : (
          <Box sx={{ py: 4, textAlign: 'center', bgcolor: '#f5f5f5', borderRadius: 2 }}>
            <LockIcon sx={{ fontSize: 48, color: '#ccc' }} />
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              No modules selected. Use the search box above to add modules and grant permissions.
            </Typography>
          </Box>
        )}
      </Box>
    );
  };

  // ─── Render Form Fields ────────────────────────────────────────────────────

  const renderFormFields = () => {
    const isEdit = activeTab === 'edit';

    return (
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2.5}>
          {/* License Type */}
          <Grid item xs={12} md={6}>
            <FieldLabel>
              License Type
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <FormControl fullWidth size="small" error={!!errors.licenseType}>
              <StyledSelect
                value={formData.licenseType || ''}
                onChange={(e) => handleFormChange('licenseType', e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled>Select license type</MenuItem>
                {licenseTypes.map((type) => (
                  <MenuItem key={type} value={type}>{type}</MenuItem>
                ))}
              </StyledSelect>
              {errors.licenseType && <FormHelperText error>{errors.licenseType}</FormHelperText>}
            </FormControl>
          </Grid>

          {/* Organization */}
          <Grid item xs={12} md={6}>
            <FieldLabel>
              Organization
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <OrganisationDropdown
              value={selectedOrganisation}
              onChange={(val: any) => {
                setSelectedOrganisation(val);
                handleFormChange('organizationId', val?.organisation_id || '');
              }}
              error={!!errors.organizationId}
              errorMessage={errors.organizationId}
              label="Select Organization"
              sx={{ mb: 0 }}
            />
          </Grid>

          {/* Business Function (Category) */}
          <Grid item xs={12} md={6}>
            <FieldLabel>
              Business Function
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <FormControl fullWidth size="small" error={!!errors.businessFunction}>
              <StyledSelect
                value={formData.businessFunction || ''}
                onChange={(e) => {
                  handleFormChange('businessFunction', e.target.value);
                  handleFormChange('subFunction', '');
                }}
                displayEmpty
              >
                <MenuItem value="" disabled>Select business function</MenuItem>
                {CATEGORIES_WITH_SUBCATEGORIES.map((cat) => (
                  <MenuItem key={cat.value} value={cat.value}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography>{cat.icon}</Typography>
                      <Typography>{cat.label}</Typography>
                    </Box>
                  </MenuItem>
                ))}
              </StyledSelect>
              {errors.businessFunction && <FormHelperText error>{errors.businessFunction}</FormHelperText>}
            </FormControl>
          </Grid>

          {/* Sub Function (Subcategory) */}
          <Grid item xs={12} md={6}>
            <FieldLabel>
              Sub Function
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <FormControl fullWidth size="small">
              <StyledSelect
                value={formData.subFunction || ''}
                onChange={(e) => handleFormChange('subFunction', e.target.value)}
                displayEmpty
                disabled={!formData.businessFunction}
              >
                <MenuItem value="" disabled>Select sub function</MenuItem>
                {formData.businessFunction && getSubCategories(formData.businessFunction).map((sub) => (
                  <MenuItem key={sub} value={sub}>{sub}</MenuItem>
                ))}
              </StyledSelect>
              {errors.subFunction && <FormHelperText error>{errors.subFunction}</FormHelperText>}
            </FormControl>
          </Grid>

          {/* Start Date */}
          <Grid item xs={12} md={6}>
            <FieldLabel>
              Start Date
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <StyledTextField
              fullWidth
              size="small"
              type="date"
              value={formData.startDate || ''}
              onChange={(e) => handleFormChange('startDate', e.target.value)}
              error={!!errors.startDate}
              helperText={errors.startDate}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* End Date */}
          <Grid item xs={12} md={6}>
            <FieldLabel>
              End Date
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <StyledTextField
              fullWidth
              size="small"
              type="date"
              value={formData.endDate || ''}
              onChange={(e) => handleFormChange('endDate', e.target.value)}
              error={!!errors.endDate}
              helperText={errors.endDate}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* User Count */}
          <Grid item xs={12} md={4}>
            <FieldLabel>
              Number of Users
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <StyledTextField
              fullWidth
              size="small"
              type="number"
              placeholder="Enter user count"
              value={formData.userCount || ''}
              onChange={(e) => handleFormChange('userCount', parseInt(e.target.value) || 0)}
              error={!!errors.userCount}
              helperText={errors.userCount}
              InputProps={{ inputProps: { min: 1 } }}
            />
          </Grid>

          {/* Cost (INR) */}
          <Grid item xs={12} md={4}>
            <FieldLabel>
              Cost (₹)
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <StyledTextField
              fullWidth
              size="small"
              type="number"
              placeholder="Enter cost in INR"
              value={formData.cost || ''}
              onChange={(e) => handleFormChange('cost', parseFloat(e.target.value) || 0)}
              error={!!errors.cost}
              helperText={errors.cost}
              InputProps={{
                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                inputProps: { min: 0, step: 1 },
              }}
            />
          </Grid>

          {/* Duration */}
          <Grid item xs={12} md={4}>
            <FieldLabel>
              Duration (months)
              <RequiredStar>*</RequiredStar>
            </FieldLabel>
            <StyledTextField
              fullWidth
              size="small"
              type="number"
              placeholder="Enter duration"
              value={formData.duration || ''}
              onChange={(e) => handleFormChange('duration', parseInt(e.target.value) || 0)}
              error={!!errors.duration}
              helperText={errors.duration}
              InputProps={{ inputProps: { min: 1 } }}
            />
          </Grid>

          {/* AI Module Toggle */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.aiModuleIncluded || false}
                  onChange={(e) => handleFormChange('aiModuleIncluded', e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <SmartToyIcon fontSize="small" />
                  <Typography variant="body2">Include AI Module</Typography>
                  <Chip label="Platinum Feature" size="small" color="secondary" sx={{ fontSize: '0.55rem', height: 18 }} />
                </Box>
              }
            />
          </Grid>

          {/* Features */}
          <Grid item xs={12}>
            <FieldLabel>Select Features</FieldLabel>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
              {availableFeatures.map((feature) => (
                <FormControlLabel
                  key={feature}
                  control={
                    <Checkbox
                      checked={formData.features?.includes(feature) || false}
                      onChange={(e) => {
                        const currentFeatures = formData.features || [];
                        if (e.target.checked) {
                          handleFormChange('features', [...currentFeatures, feature]);
                        } else {
                          handleFormChange('features', currentFeatures.filter((f) => f !== feature));
                        }
                      }}
                      size="small"
                    />
                  }
                  label={<Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{feature}</Typography>}
                />
              ))}
            </Box>
          </Grid>

          {/* ── Module Permissions ── */}
          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            {renderModulePermissions()}
          </Grid>
        </Grid>

        {/* Form Actions */}
        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            onClick={() => {
              setActiveTab('list');
              resetForm();
              setEditingLicense(null);
            }}
            sx={{ textTransform: 'none', borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={isEdit ? handleUpdateLicense : handleCreateLicense}
            disabled={isLoading}
            startIcon={isLoading ? null : <SaveIcon />}
            sx={{ textTransform: 'none', borderRadius: 2, px: 4 }}
          >
            {isLoading ? 'Saving...' : isEdit ? 'Update License' : 'Create License'}
          </Button>
        </Box>
      </Box>
    );
  };

  // ─── Render License Card ──────────────────────────────────────────────────

  const renderLicenseCard = (license: LicenseData) => {
    const daysRemaining = getDaysRemaining(license.endDate);
    const isExpiringSoon = daysRemaining <= 30 && daysRemaining > 0;
    const categoryLabel = getCategoryLabel(license.businessFunction);
    const categoryColor = getCategoryColor(license.businessFunction);
    const categoryIcon = getCategoryIcon(license.businessFunction);

    const enabledModules = Object.keys(license.modulePermissions || {}).length;
    const totalPermissions = Object.values(license.modulePermissions || {}).reduce(
      (sum, p) => sum + Object.values(p).filter(v => v === true).length,
      0
    );

    return (
      <Grow in timeout={300} key={license.id}>
        <Grid item xs={12} sm={6} md={4}>
          <LicenseCard>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <Typography variant="h6" fontWeight={600} sx={{ color: getLicenseTypeColor(license.licenseType) }}>
                      {license.licenseType}
                    </Typography>
                    <StatusBadge label={getStatusLabel(license.status)} color={getStatusColor(license.status) as any} size="small" />
                    {license.aiModuleIncluded && (
                      <Chip label="AI Module" size="small" color="secondary" sx={{ fontSize: '0.55rem', height: 20 }} />
                    )}
                  </Box>
                  <Typography variant="caption" color="textSecondary" sx={{ fontFamily: 'monospace' }}>
                    {license.licenseKey}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => handleEditLicense(license)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => {
                        setLicenseToDelete(license.id!);
                        setDeleteDialogOpen(true);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>

              <Divider sx={{ my: 1.5 }} />

              <Grid container spacing={1.5}>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography fontSize={20}>{categoryIcon}</Typography>
                    <Typography variant="body2" fontWeight={500} sx={{ color: categoryColor }}>
                      {categoryLabel}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <DashboardIcon sx={{ fontSize: 16, color: '#78909c' }} />
                    <Typography variant="body2">{license.subFunction || 'All Subcategories'}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PeopleIcon sx={{ fontSize: 16, color: '#78909c' }} />
                    <Typography variant="body2">{license.userCount} users</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AttachMoneyIcon sx={{ fontSize: 16, color: '#78909c' }} />
                    <Typography variant="body2">{formatINR(license.cost)}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <DateRangeIcon sx={{ fontSize: 16, color: '#78909c' }} />
                    <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
                      {new Date(license.startDate).toLocaleDateString()}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TimerIcon sx={{ fontSize: 16, color: isExpiringSoon ? '#d32f2f' : '#78909c' }} />
                    <Typography
                      variant="body2"
                      sx={{ color: isExpiringSoon ? '#d32f2f' : 'inherit', fontWeight: isExpiringSoon ? 600 : 400 }}
                    >
                      {daysRemaining} days left
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              {license.features.length > 0 && (
                <>
                  <Divider sx={{ my: 1.5 }} />
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {license.features.map((feature, index) => (
                      <Chip key={index} label={feature} size="small" sx={{ fontSize: '0.6rem', height: 20 }} />
                    ))}
                  </Box>
                </>
              )}

              {enabledModules > 0 && (
                <Box sx={{ mt: 1.5, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  <Chip
                    icon={<LockIcon sx={{ fontSize: 14 }} />}
                    label={`${enabledModules} modules`}
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: '0.6rem' }}
                  />
                  <Chip
                    label={`${totalPermissions} permissions`}
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: '0.6rem' }}
                  />
                </Box>
              )}
            </CardContent>
          </LicenseCard>
        </Grid>
      </Grow>
    );
  };

  // ─── Main Render ───────────────────────────────────────────────────────────

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', backgroundColor: '#f5f7fa', py: 3 }}>
      <Container maxWidth="xl">
        {/* ── Header ── */}
        <StyledAppBar position="static">
          <Toolbar disableGutters sx={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton onClick={() => navigate(-1)} size="small">
                <ArrowBackIcon />
              </IconButton>
              <Box>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  License Management
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Manage organization licenses and module permissions
                </Typography>
              </Box>
              <Chip
                label={`${licenses.length} licenses`}
                size="small"
                color="primary"
                sx={{ fontWeight: 500, fontSize: '0.7rem' }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                size="small"
                variant="outlined"
                startIcon={<RefreshIcon />}
                onClick={fetchLicenses}
                sx={{ textTransform: 'none', borderRadius: 2 }}
              >
                Refresh
              </Button>
              {activeTab !== 'create' && activeTab !== 'edit' && (
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setActiveTab('create');
                    resetForm();
                  }}
                  sx={{ textTransform: 'none', borderRadius: 2, px: 3 }}
                >
                  New License
                </Button>
              )}
            </Box>
          </Toolbar>
        </StyledAppBar>

        {/* ── Main Content ── */}
        <StyledPaper>
          {activeTab === 'list' && (
            <>
              {/* Search and Filter Bar */}
              <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
                <StyledTextField
                  placeholder="Search by license, module, or feature..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  size="small"
                  sx={{ flex: 1, minWidth: 200 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 20, color: '#78909c' }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    label="Status"
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="expired">Expired</MenuItem>
                    <MenuItem value="suspended">Suspended</MenuItem>
                  </Select>
                </FormControl>
                <Chip
                  label={`${filteredLicenses.length} results`}
                  size="small"
                  sx={{ alignSelf: 'center' }}
                />
              </Box>

              {/* License Cards */}
              {isLoading ? (
                <Box sx={{ py: 8, textAlign: 'center' }}>
                  <LinearProgress sx={{ maxWidth: 400, mx: 'auto', mb: 2 }} />
                  <Typography color="textSecondary">Loading licenses...</Typography>
                </Box>
              ) : filteredLicenses.length === 0 ? (
                <Box sx={{ py: 8, textAlign: 'center' }}>
                  <VpnKeyIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
                  <Typography variant="h6" color="textSecondary">No licenses found</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {searchTerm || filterStatus !== 'all'
                      ? 'Try adjusting your search or filters'
                      : 'Click "New License" to create one'}
                  </Typography>
                </Box>
              ) : (
                <Grid container spacing={2.5}>
                  {filteredLicenses.map((license) => renderLicenseCard(license))}
                </Grid>
              )}

              {/* Pagination */}
              {filteredLicenses.length > 0 && (
                <TablePagination
                  component="div"
                  count={filteredLicenses.length}
                  page={page}
                  onPageChange={(_, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                  }}
                  rowsPerPageOptions={[5, 10, 25]}
                  sx={{ mt: 2 }}
                />
              )}
            </>
          )}

          {/* Create/Edit Form */}
          {(activeTab === 'create' || activeTab === 'edit') && (
            <Box>
              <SectionHeader>
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main,
                  }}
                >
                  {activeTab === 'create' ? <AddIcon /> : <EditIcon />}
                </Avatar>
                <Typography variant="h6" fontWeight={600}>
                  {activeTab === 'create' ? 'Create New License' : 'Edit License'}
                </Typography>
                <Chip
                  label={activeTab === 'create' ? 'New' : 'Editing'}
                  size="small"
                  color={activeTab === 'create' ? 'success' : 'warning'}
                  sx={{ fontSize: '0.6rem' }}
                />
              </SectionHeader>
              {renderFormFields()}
            </Box>
          )}
        </StyledPaper>

        {/* ── Footer Stats ── */}
        {activeTab === 'list' && (
          <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Chip
              icon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
              label={`Active: ${licenses.filter(l => l.status === 'active').length}`}
              color="success"
              size="small"
            />
            <Chip
              icon={<ErrorIcon sx={{ fontSize: 16 }} />}
              label={`Expired: ${licenses.filter(l => l.status === 'expired').length}`}
              color="error"
              size="small"
            />
            <Chip
              label={`Pending: ${licenses.filter(l => l.status === 'pending').length}`}
              color="warning"
              size="small"
            />
            <Chip
              label={`Total Users: ${licenses.reduce((sum, l) => sum + l.userCount, 0)}`}
              variant="outlined"
              size="small"
            />
            <Chip
              label={`Total Revenue: ${formatINR(licenses.reduce((sum, l) => sum + l.cost, 0))}`}
              variant="outlined"
              size="small"
              sx={{ fontWeight: 600 }}
            />
          </Box>
        )}
      </Container>

      {/* ── Delete Confirmation Dialog ── */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Delete License</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this license? This action cannot be undone.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDeleteLicense} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LicenseDashboard;